import { Box,Skeleton,Stack,Tabs,Typography } from "@mui/material";
import Tab from '@mui/material/Tab';
import { useQuery } from '@tanstack/react-query';
import React,{ useContext,useEffect,useMemo,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { UserContext } from '../../context/UserContext';
import AttToken from '../../helpers/attToken';
import { trackEventMatomo } from '../../helpers/matomo';
import PlanoDeAcao from '../../service/PlanoDeAcao';
import { responseType } from '../../types/plano-de-acao/types';
import Avaliacao from './Avaliacao';
import Avaliados from './Avaliados';

const planosService = new PlanoDeAcao();
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function ListaHistorico() {
  const { t } = useTranslation('translation');
  const { userData } = useContext(UserContext);

  const [value, setValue] = useState<number>(0);

  useMemo(() => {
    if (!userData.inspetorPA) {
      toast.error(`${t('ActionPlan.Historico.notQualityInspector')}`, { toastId: 'erroInspetor' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData.inspetorPA]);

  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    trackEventMatomo('plano de ação', 'click', 'aba', newValue === 0 ? 'avaliação de efetividade' : 'planos avaliados');
    setValue(newValue);
  };

  const { data, isLoading, isFetching, isSuccess, isError } = useQuery({
    queryKey: ['GET_HISTORICO'],
    queryFn: async () => {
      const token = await AttToken();
      if (token) {
        const response: responseType = await planosService.getListForInspector(token);
        return response;
      }
    },
    enabled: userData.listaFuncionalidades.includes('plano-de-acao'),
    retry: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isSuccess) trackEventMatomo('plano de ação', 'sucesso', 'carregamento', 'histórico de planos carregado');
    if (isError) trackEventMatomo('plano de ação', 'erro', 'carregamento', 'falha ao carregar histórico de planos');
  }, [isError, isSuccess]);

  if (!isLoading && !isFetching && !data?.planosAvaliados?.length && !data?.planosFechados?.length) {
    return (
      <Typography variant='h4' textAlign='center' color='textDisabled'>
        {t('ActionPlan.Historico.noActionPlansInHistory')}
      </Typography>
    );
  }


  const getAvaliacao = (value: string) => {
    switch (value) {
      case 'pendente':
        return <span className='tag is-warning'>{t('ActionPlan.Historico.pending')}</span>;
      case 'malSucedido':
        return <span className='tag is-danger'>{t('ActionPlan.Historico.unsuccessful')}</span>;
      case 'bemSucedido':
        return <span className='tag is-success'>{t('ActionPlan.Historico.successful')}</span>;
    }
  };

  function Loading() {
    return (
      <Stack
        direction='column'
        width='100%'
        justifyContent='flex-start'
        alignItems='flex-start'
        spacing={2}
      >
        <Skeleton height={30} width='300px' variant="rounded" />
        {Array(5).fill(0).map((_, index) => (
          <Skeleton key={index} height={150} width='100%' variant="rounded" />
        ))}
      </Stack>

    );
  };

  return (
    isLoading || isFetching
      ? (<Loading />)
      : (<>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor='secondary'
          textColor='secondary'
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label={t('ActionPlan.Historico.effectivenessEvaluation')} value={0} />
          <Tab label={t('ActionPlan.Historico.evaluatedPlans')} value={1} />
        </Tabs>
        <Stack direction='row' width='100%' spacing={5}>
          <CustomTabPanel value={value} index={0}>
            <Avaliacao getAvaliacao={getAvaliacao} planos={data?.planosAvaliados || []} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <Avaliados getAvaliacao={getAvaliacao} planos={data?.planosFechados || []} />
          </CustomTabPanel>
        </Stack>
      </>)
  );
}
